import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect } from "react";
import Box from "@mui/material/Box";
import { useMediaQuery, useTheme } from "@mui/material";
import { useFormContext } from "react-hook-form-mui";
import { CustomSelectElement } from "../../layouts/Theme";
export default function AmountSelect({ min, max, required, label, value, setter, object }) {
    const theme = useTheme();
    const isLarge = useMediaQuery(theme.breakpoints.up('sm'));
    const { setValue } = useFormContext();
    useEffect(() => {
        if (value && !required) {
            if (max && value > max) {
                value = max;
            }
            if (setter)
                setter(value);
            setValue(object ? `amount-${object.id}` : 'amount', value);
        }
    }, [value]);
    const onChange = (value) => {
        if (setter)
            setter(value);
    };
    const options = [];
    for (let i = (min ? min : 1); i < (max ? max + 1 : 100); i++) {
        options.push({ id: i, label: i.toString() });
    }
    return (_jsx(_Fragment, { children: options.length > 1 && (_jsx(Box, { sx: { minWidth: 120, my: 1, maxWidth: isLarge ? '500px' : '100%' }, children: _jsx(CustomSelectElement, { id: object ? `amount-${object.id}` : 'amount', label: label !== null && label !== void 0 ? label : "Aantal", defaultValue: required ? undefined : value, value: value, name: object ? `amount-${object.id}` : 'amount', onChange: onChange, options: options }) })) }));
}
